export default __webpack_public_path__ + "static/logo-b0a23f1881a7359a10076c2039724867.png";